import { useQuery } from '@tanstack/react-query';
import { fetchLocations } from '../api/locations';
import type { Location } from '@deposits/shared';

export function useLocations() {
  return useQuery<Location[]>({
    queryKey: ['locations'],
    queryFn: fetchLocations,
    staleTime: 5 * 60 * 1000, // locations change rarely
  });
}
